module.exports = "<button class=\"card\">\n\t<span class=\"back\"></span>\n\t<span class=\"front t{{type}}\"></span>\n</button>\n";